export const NODE_THRESHOLDS = {
  LATEST_BLOCK_TIME_MINUTES: {
    BTC_DOGE: { RED_ABOVE: 180, AMBER_ABOVE: 120},
    DEFAULT: { RED_ABOVE: 20, AMBER_ABOVE: 10 },
  },
  LATEST_DB_TIME_MINUTES: {
    BTC: { RED_ABOVE: 240, AMBER_ABOVE: 180 },
    DOGE: { RED_ABOVE: 180, AMBER_ABOVE: 120 },
    XRPL: { RED_ABOVE: 30, AMBER_ABOVE: 15 },
    DEFAULT: { RED_ABOVE: 10, AMBER_ABOVE: 5 },
  },
  AVAILABLE_DISK_SPACE_GB: {
    RED: 40,
    AMBER: 100,
  },
  HEALTHY_PERCENTAGE: {
    RED_BELOW: 70,
    AMBER_BELOW: 90
  },
  DATABASE_INDEXING: {
    PROGRESS_RED_BELOW: 50,  // Less than 50% progress = red
    PROGRESS_AMBER_BELOW: 90, // Less than 90% progress = amber
    // Only consider remaining blocks as red if there are many left
    REMAINING_BLOCKS_RED_ABOVE: 10000, // More than 10k blocks remaining = red
    REMAINING_BLOCKS_AMBER_ABOVE: 1000  // More than 1k blocks remaining = amber
  }
};

export const BALANCE_THRESHOLDS = {
  RED_BELOW: 100,
  AMBER_BELOW: 200,
};

export const FTSO_SUBMISSIONS_THRESHOLDS = {
  PERCENTAGE: { 
    RED_BELOW: 89,
    AMBER_BELOW: 99,
  },
  ZERO_SUBS_COUNT: {
    AMBER_MIN: 1,
    AMBER_MAX: 2,
    RED_MIN: 3,
  },
  LATE_MISSING_INVALID_COUNT: {
    AMBER_MIN: 1,
    AMBER_MAX: 2,
    RED_MIN: 3,
  },
};

export const FTSO_SUMMARY_HIT_RATE_THRESHOLDS = {
  RED_BELOW: 25,
  AMBER_BELOW: 30,
};

export const FTSO_EVALUATION_TIMEFRAME = '15min'; 

export const FDC_SUBMISSIONS_THRESHOLDS = {
  PERCENTAGE: { 
    RED_BELOW: 85,
    AMBER_BELOW: 95,
  },
  MISSING_ROUNDS_COUNT: {
    AMBER_MIN: 3,
    AMBER_MAX: 4,
    RED_MIN: 5,
  },
};

export const EXTERNAL_VALIDATION_THRESHOLDS = {
  BTC: {
    GREEN_MAX: 1,
    AMBER_MAX: 2,
    RED_MIN: 3,
  },
  DOGE: {
    GREEN_MAX: 2,
    AMBER_MAX: 3,
    RED_MIN: 4,
  },
  ETH: {
    GREEN_MAX: 6,
    AMBER_MAX: 7,
    RED_MIN: 8,
  },
  FLR: {
    GREEN_MAX: 30,
    AMBER_MAX: 40,
    RED_MIN: 41,
  },
  SGB: {
    GREEN_MAX: 30,
    AMBER_MAX: 40,
    RED_MIN: 41,
  },
  XRPL: {
    GREEN_MAX: 10,
    AMBER_MAX: 20,
    RED_MIN: 30,
  },
  DEFAULT: {
    GREEN_MAX: 1,
    AMBER_MAX: 10,
    RED_MIN: 11,
  },
};

export const DATABASE_SYNC_THRESHOLDS = {
  BTC: {
    GREEN_MAX: 7,
    AMBER_MAX: 8,
    RED_MIN: 9,
  },
  DOGE: {
    GREEN_MAX: 62,
    AMBER_MAX: 63,
    RED_MIN: 64,
  },
  XRPL: {
    GREEN_MAX: 10,
    AMBER_MAX: 39,
    RED_MIN: 40,
  },
  DEFAULT: {
    GREEN_MAX: 1,
    AMBER_MAX: 5,
    RED_MIN: 6,
  },
}; 